/**
 * @param {string} dateTimeString `2019-10-08T20:00:00`
 */
function makeLocalDate(dateTimeString) {
  const p = dateTimeString.split(/-|T|:/g)
    .map(str => parseInt(str, 10));
  
  return new Date(p[0], p[1] - 1, p[2], p[3], p[4], p[5]);
}

function productionsFilter(productions) {
  const filteredProductions = [];

  productions.forEach((production) => {
    const filteredPerformances = production.performances
      .filter((perf) => {
        if (!perf.isPerformanceVisible) {
          return false;
        }

        // Weed out performances that don't have a valid displayDate
        if (!perf.displayDate && perf.displayDate === 'null') {
          return false;
        }

        return true;
      })
      .map(perf =>
        // Prep performances with any additional properties
         Object.assign({}, perf, {
           iso8601Date: makeLocalDate(perf.iso8601DateString),
         }));

    if (filteredPerformances.length > 0) {
      filteredProductions.push(Object.assign({}, production, {
        performances: filteredPerformances,
      }));
    }
  });

  return filteredProductions;
}

export default productionsFilter;
